const read = require('./read')
exports.get = read.get
exports.list = read.list
exports.listUsersByRole = read.listUsersByRole
exports.listUsersByRoutes = read.listUsersByRoutes
exports.rolesDefinition = read.rolesDefinition

const write = require('./write')
exports.prepareUserToSave = write.prepareUserToSave
exports.create = write.create
exports.update = write.update
exports.savePharmacyUser = write.savePharmacyUser
exports.assignRoute = write.assignRoute
